module.exports = __webpack_public_path__ + "static/media/projects-grey.ef7a8b59.svg";